import { useState, ReactNode, useCallback } from 'react';
import { ToastContext, ToastMethods } from './toast-context';

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Record<string, ToastMethods>>({});

  const setToast = useCallback((toastName: string, methods: ToastMethods) => {
    setToasts((prevToasts) => ({ ...prevToasts, [toastName]: methods }));
    return null;
  }, []);

  const getToast = useCallback(
    (toastName: string) => {
      return toasts ? toasts[toastName] : undefined;
    },
    [toasts]
  );

  const deleteToast = useCallback((toastName: string) => {
    setToasts((prevToasts) => {
      const newToasts = { ...prevToasts };
      delete newToasts[toastName];
      return newToasts;
    });
  }, []);

  return (
    <ToastContext.Provider
      value={{
        setToast,
        getToast,
        deleteToast,
        toasts,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
}
